import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BiHomeAlt } from "react-icons/bi";
import { Button } from "../../components/ui/button";
import Workspace from "../../components/workspace";
import BranchForm from "./branch-form";
import BranchesListContainer from "./branch-list-container";

const BranchManagementPage = () => {
   const [searchQuery, setSearchQuery] = useState("");
   const [page, setPage] = useState(1);
   const formModal = useDisclosure();

   return (
      <>
         <BranchForm modal={formModal} />
         <Workspace.TopBar heading="Branch Management" />
         <Workspace.WorkspaceActions>
            <Button variant="primary" onClick={formModal.onOpen}>
               <span className="inline-flex items-center gap-2">
                  <BiHomeAlt className=" text-lg" />
                  Add new branch
               </span>
            </Button>
         </Workspace.WorkspaceActions>
         <Workspace.ComponentWrapper>
            <Workspace.ListContainerHeader>
               <Workspace.HeaderPadding>
                  <Workspace.ListTitleWrapper>
                     <Workspace.ListTitle>Branches</Workspace.ListTitle>
                     <Workspace.HeaderSearchWrapper>
                        <Workspace.HeaderSearchForm
                           onSubmit={(e) => {
                              setPage(1);
                              setSearchQuery(e);
                           }}
                        />
                     </Workspace.HeaderSearchWrapper>
                  </Workspace.ListTitleWrapper>
               </Workspace.HeaderPadding>
            </Workspace.ListContainerHeader>
            <BranchesListContainer search={searchQuery} page={page} setPage={setPage} />
         </Workspace.ComponentWrapper>
      </>
   );
};

export default BranchManagementPage;
